<template>
  <div class="d-flex justify-content-between mb-0">
    <Badge v-if="!isModal" :title="page.title" :i="page.icon" />
    <BadgeModal v-else :title="page.title" :i="page.icon" />
  </div>
</template>
<script>
import Badge from '@/components/common/page/badge/Badge';
import BadgeModal from '@/components/common/page/badge/BadgeModal';
export default {
  meta: {
    description: 'Componente para agregar títulos de encabezado por páginas.',
    slots: {
      default: {
        type: 'component',
        valid: [],
      },
    },
  },
  components: {
    Badge,
    BadgeModal,
  },
  props: {
    isModal: {
      type: Boolean,
      default: false,
      meta: {
        description: 'Utilizado para cambiar los elementos de icono y título. ',
        example: 'true',
      },
    },
    page: {
      type: Object,
      default: () => {},
      meta: {
        description: 'Estable el icono y título.',
        example: 'Objeto Requerido',
      },
    },
  },
};
</script>
